module.exports = __webpack_public_path__ + "media/application/images/projects/images/scotland_sea-7ee4976e2f8898d541072e9d2c2589a0.jpg";